export default __webpack_public_path__ + "static/media/profile.9535cb38.png";